import { Box, Grid, Button } from '@mui/material'
import React, { useState, useEffect, useMemo } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Stack from '@mui/material/Stack';
import useFetch from "../../../utils/useFetch";
import MuiSelect from "@mui/material/Select";
import {
  FormControl, MenuItem, ListSubheader, TextField, InputAdornment,
  Tooltip, Select, Table, TableCell, Accordion, AccordionSummary, TableRow, Typography, AccordionDetails
} from '@mui/material'
import axios from "../../../utils/fvAxios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getisEmp, getMoodleUserId, getOrgId, getOrgType } from "../../../utils/Token";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import FormControlDroupdown from "../../../components/FormControl";
import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";


export default function AddTocart({ activestep }) {

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 224,
        width: 100,
        //minWidth: parentWidth
      }
    },
    autoFocus: false
  };
  const [checked, setChecked] = useState([]);

  const [getCourse, setCourses] = React.useState([]);



  const { data: res } = useFetch(
    "Employee/GetCourses?VendorId=" + getOrgId());
  useEffect(() => {
    if (res?.data) {
      setCourses(res?.data?.filter(course => course.coursename !== "Select"))
    }
  }, [res]);


  const groupedData = getCourse?.reduce((result, item) => {
    const clientName = item?.clientName;
    if (!result[clientName]) {
      result[clientName] = [];
    }
    result[clientName]?.push(item);
    return result;
  }, {});

  const groupedArray = Object.entries(groupedData)
    ?.map(([clientName, items]) => ({
      clientName,
      items: items?.sort((a, b) => a?.coursename?.localeCompare(b?.coursename)), // Sort items by coursename
    }))
    ?.sort((a, b) => a?.clientName?.localeCompare(b?.clientName));


  const [selectedClients, setSelectedClient] = useState('');
  const [courseID, setcourseID] = useState([]);
  const [error, setError] = useState(null);
  const [courseD, setcourse] = useState("");
  const [openSelectOptions, setOpenSelectOptions] = useState(false);
  const [searchText, setSearchText] = useState("");

  const IsEmp = getisEmp();
  const MoodEmpId = getMoodleUserId();


  const ClearSearch = () => {
    setSearchText("");
  };

  const handleClientChange = (e) => {
    setcourseID([]);
    const selectedItem = e?.target?.value;
    //setcourse(selectedItem);
    setSelectedClient(selectedItem);
    setSelectAllChecked(false);
    setIsLoading(true);

    if (selectedItem) {

      axios
        .get(`Employee/GetEmployeesByCourse?VendorId=${getOrgId()}&CourseId=${selectedItem?.courseid}`)
        .then((resp) => {
          if (resp?.data?.responseCode === 100) {
            // for employees 
            if (IsEmp == "true") {
              const Info = resp?.data?.data?.filter((r) => r?.userid == MoodEmpId)
              setcourseID(Info);
              if (Info?.length == 1) {
                handleCheckboxChange(Info[0], selectedItem)
              }
              // for employees 
            } else {
              setcourseID(resp?.data?.data);
            }
          } else {
            setError(resp?.data?.responseMessage);
            if (resp?.data?.responseMessage === "Annual fee not paid for the selected training") {
              setOpen(true);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        }).finally(() => {
          setIsLoading(false);
        })
    }
  };
  const [checkedItems, setCheckedItems] = useState({});
  const [checkedItems1, setCheckedItems1] = useState({});
  const [checkedItems2, setCheckedItems2] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ishidden, setIsHidden] = useState('');
  const [ishidden1, setIsHidden1] = useState('');


  const handleCheckboxChange = (user, selectedItem) => {
    const key = `${user?.userid}_${selectedItem?.courseid}`;
    setIsHidden1(key)
    setIsHidden((prevCheckedItems) => ({
      ...prevCheckedItems,
      [key]: {
        isChecked: !prevCheckedItems[key]?.isChecked,

      },
    }))
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [key]: {
        isChecked: !prevCheckedItems[key]?.isChecked,
        user: user,
        selectedItem: selectedItem,
      },
    }));
  };

  const checkedGroups = Object.values(checkedItems1)?.filter(item => item?.isChecked);


  const groupedCourses = checkedGroups?.reduce((result, item) => {
    const coursename = item?.selectedItem?.coursename;
    if (!result[coursename]) {
      result[coursename] = [];
    }
    result[coursename]?.push(item);
    return result;
  }, {});

  const handleSelectAllChange = (users) => {
    setSelectAllChecked(!selectAllChecked);
    setIsHidden1(!selectAllChecked)
    const updatedCheckedItems = {};
    users.forEach((user) => {
      const key = `${user?.userid}_${selectedClients?.courseid}`;
      updatedCheckedItems[key] = {
        isChecked: !selectAllChecked,
        user: user,
        selectedItem: selectedClients,
      };
    });
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      ...updatedCheckedItems,
    }));
  };


  const handleDelete = (key) => {
    setSelectAllChecked(false)
    setCheckedItems((prevCheckedItems) => {
      const updatedCheckedItems = { ...prevCheckedItems };
      updatedCheckedItems[key].isChecked = false;
      return updatedCheckedItems;
    });
  };

  const handleTransfer = () => {
    setCheckedItems1(checkedItems)
  };



  const HandleNext = async (value) => {
    const checkedValues = Object.values(checkedItems1)?.filter(item => item?.isChecked);
    const userRoles = checkedValues.reduce((result, currentItem) => {
      const courseId = currentItem?.selectedItem?.courseid;
      result.push({
        "courseId": courseId,
        "fvEmpId": "00000000-0000-0000-0000-000000000000",
        "courseName": currentItem?.selectedItem?.coursename,
        "moodleEmpId": currentItem?.user?.userid + "",
        "employeeName": currentItem?.user?.lastname + " " + currentItem?.user?.firstname,
        "empStatus": true,
        "clientId": currentItem?.selectedItem?.clientId,
        "courseStatus": true,
        "courseFee": currentItem?.selectedItem?.coursefee,
        "clientName": currentItem?.selectedItem?.clientName,
        "expiryMonth": currentItem?.selectedItem?.expiryMonth,
        "isProRateRequired": currentItem?.selectedItem?.isProRataRequired
      });
      return result;
    }, []);

    const obj = {
      "vendorId": getOrgId(),
      "empCourses": userRoles,
      "payType": 2
    };
    setCheckedItems2(obj)
    const res = await axios.post("Employee/AddEmployeesToCart", obj)
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          activestep(value)
        } else {

        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {

      })
  }
  const [open, setOpen] = React.useState(false);

  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloading1, setIsDownloading1] = useState(false);
  const DownloadTraingGuide = () => {
    setIsDownloading(true);
    axios.get("Documents/DownloadDoc?fileName=Employer Guide-Adding employees.pdf", {
      responseType: 'blob'
    })
      .then(res => {
        setIsDownloading(false);
        const file = new Blob([res?.data], { type: "application/pdf", name: "Employer Guide-Adding employees.pdf" });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');
      });
  }

  const DownloadCourses = () => {
    setIsDownloading1(true);
    axios.get("Documents/DownloadDoc?fileName=List of Courses from UL Solutions.pdf", {
      responseType: 'blob'
    })
      .then(res => {
        setIsDownloading1(false);
        const file = new Blob([res?.data], { type: "application/pdf", name: "List of Courses from UL Solutions.pdf" });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');
      });
  }



  const handleClose = () => {
    setOpen(false);
  };
  const areAnyCheckboxesChecked = () => {
    return Object.values(checkedItems)?.some(item => item?.isChecked);
  };
  // console.log(checkedItems[0]["isChecked"]);
  const StyledTableRow = styled(TableRow)(({ theme }) => ({

    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={"lg"}
        maxWidth={"lg"}
      >
        <DialogTitle id="alert-dialog-title">

        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ color: "black" }}>
            Training can't be assigned as the annual fee associated with the selected training is not completed. Please go to the questionnaire payment page and complete payment for annual fees.
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button onClick={handleClose} variant="contained" sx={{ width: "100%", padding: "20px" }}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12} sm={8} md={8}>
          <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: "10px", backgroundColor: "#fff" }}>
            <p style={{ color: "#101828", fontSize: "20px", marginBottom: "20px", fontWeight: "600" }}>Add Courses to Cart</p>

            {isDownloading ? (
              <CircularProgress />
            ) : (
              <a style={{ color: "#2A93DB", fontSize: "14px", cursor: "pointer" }} onClick={DownloadTraingGuide}>
                <InsertDriveFileOutlinedIcon /> Employer Guide-Adding employees.pdf
              </a>
            )}
            <br />
            {isDownloading1 ? (
              <CircularProgress />
            ) : (
              <a style={{ color: "#2A93DB", fontSize: "14px", cursor: "pointer" }} onClick={DownloadCourses}>
                <InsertDriveFileOutlinedIcon /> List of Courses from UL Solutions.pdf
              </a>
            )}

            <p className='mt-3' style={{ color: "red", fontWeight: "bold" }}>
              {/* Note: You cannot assign training videos to your employee if the respective client status is N/A or Expired. */}
              Client courses cannot be assigned if the respective client status is N/A or Expired.
              <br />
              <br />
              Courses from UL Solutions can be assigned at any time without selecting a client questionnaire.
            </p>
            {/* <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedClients}
              label="Client Name"
              onChange={handleClientChange}
              displayEmpty
              sx={{
                width: "300px",
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 },
                fontFamily: 'Arial, FontAwesome',
              }}
              MenuProps={{
                PaperProps: MenuProps.PaperProps,
              }}
            >
              <MenuItem value="" >
                Select
              </MenuItem>

              {groupedArray?.map((group, index) => [
                <ListSubheader key={index} sx={{ lineHeight: "22px", color: "#fff", backgroundColor: "#b9b3b3" }} title={group?.clientName}>
               
                  <div style={{ width: "323px" }}>
                    <span style={{}}>{group?.clientName === "null" ? "" : group?.clientName}</span></div>
                </ListSubheader>,
                ...group?.items.map((item) => (
                  <MenuItem key={item?.courseid} value={item} title={item?.coursename} >
                    <div style={{ width: "280px", textOverflow: "ellipsis", overflowX: "hidden", }} hidden={item?.coursename === "Select"}>
                      {item?.coursename === "Select" ? "" : item?.coursename}
                    </div>
                  </MenuItem>
                )),
                index < groupedArray?.length - 1,
              ])}
            </Select> */}
            <div style={{ display: "flex" }}>
              <FormControl>
                <MuiSelect
                  className="select-input"
                  variant="outlined"
                  value={selectedClients}
                  onChange={handleClientChange}
                  MenuProps={MenuProps}
                  IconComponent={KeyboardArrowDownIcon}
                  onClose={ClearSearch}
                  sx={{
                    width: "300px",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    color: "black",
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#667085",
                      border: "1px solid #667085"
                    }
                  }}

                >
                  <Box sx={{ display: "flex", alignItems: "center", px: 1, marginBottom: "3px" }}>
                    <TextField
                      size="small"
                      placeholder="Search..."
                      value={searchText}
                      onChange={(e) => setSearchText(e?.target?.value)}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        )
                      }}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {

                          e.stopPropagation();
                        }
                      }}
                    />
                    <IconButton size="small"
                      onClick={ClearSearch}
                    >
                      <CancelSharpIcon />
                    </IconButton>
                  </Box>
                  {groupedArray?.flatMap((group) => {
                    const filteredItems = group?.items?.filter((item) =>
                      item?.coursename?.toLowerCase()?.includes(searchText?.toLowerCase())
                    );
                    if (filteredItems?.length === 0) return [];
                    return [
                      <ListSubheader
                        key={`header-${group?.clientName}`}
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          backgroundColor: "#dadada",
                          fontSize: "14px",
                        }}
                      >
                        {group?.clientName}
                      </ListSubheader>,
                      ...filteredItems.map((item) => (
                        <MenuItem
                          key={item?.courseid}
                          value={item}
                          title={item?.coursename}
                        >
                          {item?.coursename}
                        </MenuItem>
                      )),
                    ];
                  })}

                </MuiSelect>
              </FormControl>

              <Tooltip title={<span >
                Note:
                <br />
                In this section, select the orientation videos.
                <br />
                In the bottom section, select the employee(s).
              </span>} arrow>
                <IconButton hidden={IsEmp == "true"}>
                  <InfoOutlinedIcon />
                </IconButton>
              </Tooltip>

            </div>

            <br />
            <p style={{ color: "red", fontWeight: "bold" }} hidden={IsEmp == "true"}>Select the employees to whom the above selected training has to be assigned.</p>

            <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" tag={"div"} hidden={IsEmp == "true"} sx={{ padding: 1, marginTop: 1, overflowY: "auto", maxHeight: "209px", height: "300px", marginBottom: 1, backgroundColor: "#fff" }}>
              <List>
                <ListItem key="select-all" hidden={courseID?.length === 0 || (IsEmp == "true" && courseID?.length == 1)}>
                  <Checkbox
                    checked={selectAllChecked}
                    onChange={() => handleSelectAllChange(courseID)}
                  />
                  <ListItemText primary="Select All" onClick={() => handleSelectAllChange(courseID)} sx={{ cursor: "pointer" }} />
                </ListItem>
                {courseID?.map((user) => (
                  <ListItem key={user?.userid}>
                    <Checkbox
                      checked={checkedItems[`${user?.userid}_${selectedClients?.courseid}`]?.isChecked || false}
                      onChange={() => handleCheckboxChange(user, selectedClients)}
                    />
                    <ListItemText
                      primary={`${user?.firstname} ${user?.lastname}`}
                      onClick={() => handleCheckboxChange(user, selectedClients)}
                      sx={{ cursor: "pointer" }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
            <br />
            <Button
              variant="outlined"
              sx={{ padding: "10px" }}
              onClick={handleTransfer}
              style={{ display: areAnyCheckboxesChecked() ? 'block' : 'none' }}
              hidden={IsEmp == "true" && courseID?.length == 0}
            >
              + Add to Cart
            </Button>

          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4} >
          {Object?.entries(groupedCourses)?.length > 0 && (
            <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: "10px", backgroundColor: "#fff" }}>
              <p style={{ color: "#101828", fontSize: "20px", marginBottom: "20px", fontWeight: "600" }}>Order Summary</p>
              <p>     <InfoOutlinedIcon /> <span style={{ color: "red", fontWeight: "bold" }}>Discount will be applied in the
                next page</span></p>
              <Box tag={"div"} sx={{ padding: 1, marginTop: 1, overflowY: "auto", maxHeight: "600px", height: "400px", marginBottom: 1, backgroundColor: "#fff" }}>
                {Object?.entries(groupedCourses)?.map(([coursename, groups]) => (
                  <Accordion key={coursename} sx={{ marginTop: "5px" }} >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      style={{ color: "#2A93DB", backgroundColor: "#DEEDF7", padding: "5px" }}
                    >
                      {/* <Typography sx={{width:"77%",textOverflow:"ellipsis"}}>
                        <span>     {coursename}</span>
                   
                        </Typography>
                      <Typography align='right'>${groups.reduce((total, item) => total + item.selectedItem.coursefee, 0)}</Typography> */}
                      <Table size="small" aria-label="purchases">

                        <StyledTableRow >
                          <TableCell style={{ width: "60%" }}><Typography sx={{ textOverflow: "ellipsis" }}>
                            <span>     {coursename}</span>

                          </Typography></TableCell>
                          <TableCell align='right' sx={{ fontSize: "16px" }}>${groups?.reduce((total, item) => total + item?.selectedItem?.coursefee, 0)}</TableCell>

                          <TableCell align='right'>&nbsp;</TableCell>
                        </StyledTableRow>

                      </Table>
                    </AccordionSummary>
                    <AccordionDetails style={{ padding: "0px" }}>
                      <List>

                        <Table size="small" aria-label="purchases">
                          {groups?.map((group) => (
                            <StyledTableRow key={`${group?.user?.userid}_${group?.selectedItem?.courseid}`}>
                              <TableCell sx={{ fontSize: "16px", width: "60%" }}>{`${group?.user?.lastname} ${group?.user?.firstname}`}</TableCell>
                              <TableCell align='right' sx={{ fontSize: "16px" }}>${group?.selectedItem?.coursefee}</TableCell>
                              <TableCell align='right'>
                                <DeleteOutlineIcon style={{ cursor: "pointer", fontSize: "19px" }} onClick={() => handleDelete(`${group?.user?.userid}_${group?.selectedItem?.courseid}`)} />
                              </TableCell>
                            </StyledTableRow>
                          ))}
                        </Table>
                      </List>
                    </AccordionDetails>
                  </Accordion>

                ))}

                <div style={{ padding: "10px" }}>
                  <Button variant="contained" sx={{ padding: "10px" }} onClick={() => HandleNext(1)}>
                    Next
                  </Button>
                </div>
              </Box>

            </Box>
          )}
        </Grid>

      </Grid>

    </>
  )
}
